import { useEffect, useState } from 'react';
import { useCachedImageSrc } from '../../hooks/useCachedImageSrc';

/**
 * <img> that survives no service: served from the image store once seen (lib/images/imageCache.js).
 * `fallback` renders while there is nothing to show (not stored, no service) and after a load error - and a
 * stored copy that swaps in after a failed plain load is shown, not hidden behind the error.
 */
export default function CachedImg({ src: url, fallback = null, onError, ...rest }) {
  const { src, onLoad, retryKey } = useCachedImageSrc(url);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setFailed(false);
  }, [src, retryKey]);
  if (!src || failed) return fallback;
  return (
    <img
      key={retryKey}
      src={src}
      onLoad={onLoad}
      onError={(e) => {
        setFailed(true);
        onError?.(e);
      }}
      {...rest}
    />
  );
}
